$("#formLogin").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            //target: 'status-envio',
            beforeSubmit: function () {
                $('#formLogin #btnLogin').addClass('loader').html(__('Enviando...Aguarde.')).attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                if (parseInt(result[1]) == 1) {
                    $('#formLogin #btnLogin').removeClass('loader').addClass('success').html(result[2]);
                    setTimeout(function () {
                        location.href = './' + result[3];
                    }, 2000);
                } else if (parseInt(result[1]) == 3) {
                    Swal.fire({
                        title: result[2],
                        icon: 'warning',
                        allowOutsideClick: false,
                        showCancelButton: true,
                        showConfirmButton: false,
                        cancelButtonColor: '#1c2f33',
                        cancelButtonText: 'OK'
                    }).then(function (res) {
                        $('#formLogin #btnLogin').removeClass('loader').html('Login').attr('disabled', false);
                    });
                } else {
                    $('#formLogin #btnLogin').removeClass('loader').addClass('error').html(result[2]);
                    setTimeout(function () {
                        $('#formLogin #btnLogin').removeClass('error').html('Login').attr('disabled', false);
                    }, 3000);
                }
            }
        });
    }
});

if ($('.formCadastroStep1 #formCadastroStep2__CPF').length) {
    // $(document).on('blur', '.formCadastroStep1 #formCadastroStep2__CPF', function () {
    //     if (!validaCPF($("#formCadastroStep2__CPF").val())) {
    //         Swal.fire({
    //             title: 'CPF inválido!',
    //             icon: 'warning',
    //             showCancelButton: false,
    //             confirmButtonColor: '#1c2f33',
    //             cancelButtonColor: '#d33',
    //             confirmButtonText: 'OK'
    //         });
    //         $("#formCadastroStep2__CPF").val('');
    //     }
    // });

    $(document).on('keyup', '.formCadastroStep1 #formCadastroStep2__CPF', function () {
        var testeCPF = validaCPF($(this).val());
        console.log(testeCPF, $(this).val().length, $(this).val());
        var cpf = $(this).val().replace(/\D/g, ""); // somente numero
        if (testeCPF) {
            console.log('OK - SUBMIT');
            $('.formCadastroStep1').submit();
        } else if (!testeCPF && cpf.length == 11) {
            Swal.fire({
                title: 'CPF inválido!',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#1c2f33',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK'
            });
        } else {
            // alert('invalido');
        }
    });

};

if ($('.formCadastroStep1').length) {

    $('#formCadastroStep2__modalidade').on('change', function () {
        var mode = $(this).val();
        if (mode === 'A') {
            $(".l_BR span.opcional").show();
            $('#formCadastroStep2__CNPJ').removeAttr('required', 'required').val('');
            $('#formCadastroStep2__escritorio').removeAttr('required', 'required').val('');
        } else {
            $(".l_BR span.opcional").hide();
            $('#formCadastroStep2__escritorio').attr('required', 'required');
            $('#formCadastroStep2__CNPJ').removeAttr('required', 'required').val('');
        }
    });

    $('#formCadastroStep2__profissao').on('change', function () {
        if ($(this).val() === 'Arquiteto') {
            $("#formCadastroStep2__CREA").attr('required', 'required').removeAttr('readonly').val('');
        } else {
            $("#formCadastroStep2__CREA").removeClass('error').removeAttr('required', 'required').val('');
        }
    });

    $(".formCadastroStep1").validate({
        rules: {
            email_cad: "required",
            email_confirm: {
                equalTo: "#email_cad"
            },
            formCadastroStep2__senha: "required",
            formCadastroStep2__senha2: {
                equalTo: "#formCadastroStep2__senha"
            }
        },
        submitHandler: function (form) {
            //SUBMIT form
            if (validaCPF($("#formCadastroStep2__CPF").val())) {
                $(form).ajaxSubmit({
                    //target: 'status-envio',
                    beforeSubmit: function () {
                        $('.formCadastroStep1 .c-stsSend').removeClass('u-dnone');
                        $('.formCadastroStep1 .c-stsSend__feedback--load').removeClass('u-dnone');
                        $('.formCadastroStep1  #btnStep1').attr('disabled', true);
                        $('.formCadastroStep1  #btnStep2').attr('disabled', true);
                    },
                    success: function (result) {
                        result = result.split('|');
                        if (parseInt(result[1]) == 3) {
                            $('.formCadastroStep1 .c-stsSend').addClass('u-dnone');
                            $('.formCadastroStep1 .c-stsSend__feedback').addClass('u-dnone');
                            $('#idStep').val('register');
                            $('.passo-2').removeClass('d-none');
                            $('.formCadastroStep1  #btnStep2').attr('disabled', false);
                        } else if (parseInt(result[1]) == 1) {
                            //$('.formCadastroStep1 .c-stsSend__feedback').addClass('u-dnone');
                            //$('.formCadastroStep1 .c-stsSend__feedback--success').removeClass('u-dnone');
                            //$('.formCadastroStep1 .c-stsSend__feedback--success span').html(result[2]);
                            $('#cod_cadastro').val(result[3]);
                            $('#email_cadastro').val(result[4]);
                            $('#nome_cadastro').val(result[5]);
                            setTimeout(function () {
                                $('.formCadastroStep1 input').attr('readonly', 'readonly');
                                $('.formCadastroStep1 #btnStep1').attr('disabled', false).addClass('u-dnone');
                                //$('.formCadastroStep1 .c-stsSend').addClass('u-dnone');
                                //$('.formCadastroStep1 .c-stsSend__feedback').addClass('u-dnone');
                                //$('.formCadastroStep2').removeClass('u-dnone');
                                //window.location.href = location.protocol + '//' + location.host + location.pathname;
                                location.href = 'obrigado?token=' + result[3]
                            }, 2000);
                        } else if (parseInt(result[1]) == 4) {
                            setTimeout(function () {
                                $('.formCadastroStep1 .c-stsSend').addClass('u-dnone');
                                $('.formCadastroStep1 .c-stsSend__feedback').addClass('u-dnone');
                                $('.formCadastroStep1 #btnStep2').attr('disabled', false);
                            }, 2000);
                            Swal.fire({
                                title: result[2],
                                icon: 'warning',
                                allowOutsideClick: false,
                                showCancelButton: true,
                                showConfirmButton: false,
                                cancelButtonColor: '#1c2f33',
                                cancelButtonText: 'OK'
                            }).then(function (res) {
                                location.href = './';
                            });
                        } else if (parseInt(result[1]) == 2) {
                            setTimeout(function () {
                                $('.formCadastroStep1 .c-stsSend').addClass('u-dnone');
                                $('.formCadastroStep1 .c-stsSend__feedback').addClass('u-dnone');
                                $('.formCadastroStep1 #btnStep2').attr('disabled', false);
                            }, 2000);
                            Swal.fire({
                                title: result[2],
                                text: result[3],
                                icon: 'warning',
                                allowOutsideClick: false,
                                showCancelButton: false,
                                confirmButtonColor: '#3e3e3e',
                                cancelButtonColor: '#d33',
                                confirmButtonText: result[4]
                            }).then(function (res) {
                                if (res.value) {
                                    location.href = result[5];
                                    console.log(result[5])
                                }
                            });
                        } else {
                            $('.formCadastroStep1 .c-stsSend__feedback').addClass('u-dnone');
                            $('.formCadastroStep1 .c-stsSend__feedback--error').removeClass('u-dnone');
                            $('.formCadastroStep1 .c-stsSend__feedback--error span').html(result[2]);
                            setTimeout(function () {
                                $('.formCadastroStep1 .c-stsSend').addClass('u-dnone');
                                $('.formCadastroStep1 .c-stsSend__feedback').addClass('u-dnone');
                                $('.formCadastroStep1 #btnStep2').attr('disabled', false);
                            }, 3000);
                        }
                    }
                });
            }
        }
    });
}

if ($('.formEsqueceuSenha').length) {
    $(".formEsqueceuSenha").validate({
        submitHandler: function (form) {

            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('.formEsqueceuSenha .c-stsSend').removeClass('u-dnone');
                    $('.formEsqueceuSenha .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('.formEsqueceuSenha  #btnEmail').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) == 1) {
                        $('.formEsqueceuSenha .c-stsSend__feedback').addClass('u-dnone');
                        $('.formEsqueceuSenha .c-stsSend__feedback--success').removeClass('u-dnone');
                        $('.formEsqueceuSenha .c-stsSend__feedback--success span').html(result[2]);
                        setTimeout(function () {
                            window.location = result[3] + 'login';
                        }, 5000);
                    } else {
                        $('.formEsqueceuSenha .c-stsSend__feedback').addClass('u-dnone');
                        $('.formEsqueceuSenha .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('.formEsqueceuSenha .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('.formEsqueceuSenha .c-stsSend').addClass('u-dnone');
                            $('.formEsqueceuSenha .c-stsSend__feedback').addClass('u-dnone');
                            $('.formEsqueceuSenha #btnEmail').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

if ($('.formCadLojista').length) {
    // STEP VERIFICA SE TEM LOJA
    $(document).on('click', '.btnVerificaPreCadastro', function (e) {
        e.preventDefault();
        var cnpj = $('#formCadLojista__cnpj').val();
        var pais = $('#formCadLojista__pais').val();
        var codigo = $(this).attr('data-codigo');
        $('.formCadLojista__content').html('<li class="u-fw100 msg-situacao-cadastro"><p>' + __('Aguardando') + ' ...</p></li>');
        $.ajax({
            type: "POST",
            data: { formCadLojista__cnpj: cnpj, formCadLojista__pais: pais, formCadLojista__codigo: codigo },
            url: "verifica-pre-cadastro",
            success: function (result) {
                $('.formCadLojista__content').html(result);

                if (pais == 'BR') {
                    $('#formCadLojista__cpf_pessoa').mask("999.999.999-99");
                    $('#formCadLojista__cpf_pessoa2').mask("999.999.999-99");
                } else {
                    $('#formCadLojista__cpf_pessoa').unmask();
                    $('#formCadLojista__cpf_pessoa2').unmask();
                    $('#formCadLojista__cpf_pessoa').addClass('dataOnlyNumber');
                    $('#formCadLojista__cpf_pessoa2').addClass('dataOnlyNumber');
                }
            }
        });
    });

    // STEP 2
    $(".formCadLojista").validate({
        rules: {
            formCadLojista__email_cad: "required",
            formCadLojista__email_cad_confirm: {
                equalTo: "#formCadLojista__email_cad"
            },
            formCadLojista__senha: "required",
            formCadLojista__senha_confirm: {
                equalTo: "#formCadLojista__senha"
            },
            formCadLojista__email2_cad: "required",
            formCadLojista__email2_cad_confirm: {
                equalTo: "#formCadLojista__email2_cad"
            },
            formCadLojista__senha2: "required",
            formCadLojista__senha2_confirm: {
                equalTo: "#formCadLojista__senha2"
            }
        },
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('.formCadLojista .c-stsSend').removeClass('u-dnone');
                    $('.formCadLojista .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('.formCadLojista  #btnEnviar').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) == 1) {
                        $('.formCadLojista .c-stsSend__feedback').addClass('u-dnone');
                        $('.formCadLojista .c-stsSend__feedback--success').removeClass('u-dnone');
                        $('.formCadLojista .c-stsSend__feedback--success span').html(result[2]);
                        setTimeout(function () {
                            $('.formCadLojista input').attr('readonly', 'readonly');
                            $('.formCadLojista #btnEnviar').attr('disabled', false).addClass('u-dnone');
                            $('.formCadLojista .c-stsSend').addClass('u-dnone');
                            $('.formCadLojista .c-stsSend__feedback').addClass('u-dnone');
                            $('.formCadastroStep2').removeClass('u-dnone');
                            location.reload();
                        }, 4000);
                    } else {
                        $('.formCadLojista .c-stsSend__feedback').addClass('u-dnone');
                        $('.formCadLojista .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('.formCadLojista .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('.formCadLojista .c-stsSend').addClass('u-dnone');
                            $('.formCadLojista .c-stsSend__feedback').addClass('u-dnone');
                            $('.formCadLojista #btnEnviar').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

if ($('body').hasClass('home-popup')) {
    $(window).on('load', function () {
        Swal.fire({
            width: 800,
            //title: 'Sweet!',
            //text: 'Modal with a custom image.',
            imageUrl: 'uploads/popups/lancamento-2021.jpeg',
            imageWidth: 800,
            imageAlt: 'Custom image',
            showConfirmButton: true,
            confirmButtonColor: '#1c2f33',
            confirmButtonText: __('Cadastre-se'),

            showCancelButton: true,
            cancelButtonColor: '#357076',
            cancelButtonText: __('Fechar'),

            allowOutsideClick: false,
            allowEscapeKey: false
        }).then(function (result) {
            console.log(result, result.isConfirmed, result.value);
            if (result.value) {
                location.href = 'https://ww1.eliane.com/connectarch/webinar/?idc=NjU%3D&src=1';
            }
        })
    });
}